module.exports = __webpack_public_path__ + "static/media/carla.3e65499c.jpg";